module.exports = " <div class=colors> <h4 class=text-uppercase v-if=render_colors.length>Color</h4> <div class=color-container> <div class=colors v-for=\"color in render_colors\"> <div class=square :style=\"`background-color: ${ color.color }`\" data-toggle=tooltip :title=color.color_name @click=\"selectColor($event, color)\"></div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/Color.vue
// module id = 553
// module chunks = 0